import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Generator from "@/pages/Generator";
import ReferenceGenerator from "@/pages/ReferenceGenerator";
import PublicReferencePage from "@/pages/PublicReferencePage";
import PosterKit from "@/pages/PosterKit";
import Dashboard from "@/pages/Dashboard";
import SavedProjects from "@/pages/SavedProjects";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Profile from "@/pages/Profile";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Accessibility from "@/pages/Accessibility";
import Support from "@/pages/Support";
import NotFound from "@/pages/NotFound";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

function AppRoutes() {
  const location = useLocation();
  // Emergent OAuth returns with #session_id=... — handle before anything else.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/generator" element={<Generator />} />
        <Route path="/reference/new" element={<ProtectedRoute><ReferenceGenerator /></ProtectedRoute>} />
        <Route path="/reference/:projectId/edit" element={<ProtectedRoute><ReferenceGenerator /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/projects" element={<ProtectedRoute><SavedProjects /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/accessibility" element={<Accessibility />} />
        <Route path="/support" element={<Support />} />
        <Route path="/contact" element={<Navigate to="/support" replace />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      {/* Public reference page — full width, no app chrome */}
      <Route path="/r/:publicId" element={<PublicReferencePage />} />
      <Route path="/poster/:publicId" element={<PosterKit />} />
      {/* Auth pages — outside main layout */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
